import React from 'react';
import { Box } from '@amzn/awsui-components-console';
import ValidationPanel from './ValidationPanel';
import { ValidationDefinition } from './configureAttributeStep.types';
import { ValidationMetadataSummary } from './validationMetadataApi';

interface TaskValidationsSectionProps {
	taskName: string;
	validations: ValidationDefinition[];
	operationOptions: { label: string; value: string }[];
	onUpdate: (validations: ValidationDefinition[]) => void;
	taskInputAttributeIds?: string[];
	validationMetadataSummaries?: ValidationMetadataSummary[];
}

export default function TaskValidationsSection({
	taskName,
	validations,
	operationOptions,
	onUpdate,
	taskInputAttributeIds,
	validationMetadataSummaries,
}: TaskValidationsSectionProps) {
	return (
		<Box padding={{ top: 's' }}>
			<Box variant="h4" padding={{ bottom: 'xxs' }}>
				{`Validations for ${taskName}`}
			</Box>
			<Box variant="small" color="text-status-inactive" padding={{ bottom: 's' }}>
				Validations apply to this task and may reference one or more of its attributes.
			</Box>
			<ValidationPanel
				validations={validations}
				onUpdate={onUpdate}
				operationOptions={operationOptions}
				taskInputAttributeIds={taskInputAttributeIds}
				validationMetadataSummaries={validationMetadataSummaries}
			/>
		</Box>
	);
}